import { Type } from '../../../../general/modules/filter/dataModel';
import { PLOT_RECOGNITION_STATUS_LABELS } from '../../../../general/modelPlotRecognition';
import { CHNodePlotRecognitionStatus } from '../../../../general/node';
import { RecognitionCellInner } from '../components/cells/RecognitionCell';
import { FilterEnumContainer } from '../components/plugins/filters/FilterEnumContainer';
import { Column, FMColumn } from '../model';

/**
 * Столбец `AI Metadata` — статус AI-разметки сюжета (MYUA-16736). Сортировка и фильтрация
 * клиентские, как у остальных столбцов: сортировка по значению `getter`, фильтр-enum строит
 * список опций из `getter`/`toDisplayString` загруженных нод.
 */
export const recognitionCol: FMColumn<Type.ID> = {
  key: Column.recognition,
  dataKey: Column.recognition,
  title: 'AI Metadata',
  width: 160,
  sortable: true,
  cellRenderer: RecognitionCellInner,
  className: 'ch-file-manager__cell_recognition',
  plugins: [FilterEnumContainer],
  filter: Type.ID,
  getter: (row) => CHNodePlotRecognitionStatus(row),
  toDisplayString: (row) => {
    const status = CHNodePlotRecognitionStatus(row);
    return status === null ? null : PLOT_RECOGNITION_STATUS_LABELS[status];
  },
};
